<template>
	<div class="tabWrapperSettings">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="positionsPositions"
				@updateClickButton="onClickButton($event, flag)"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateCreate="onCreate"
				text-create="Add new position"
				page-title="Positions"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-positions
				v-if="isViewPositions"
				:dialogFlag="dialogFlag"
				:editPositions="editPositions"
				:departmentsDepartments="departmentsDepartments"
				@updateSave="onSaveViewPositions"
				@updateClose="onCloseDialog('isViewPositions')"
				@updateList="onUpdateList('positions')"
		></view-positions>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabPositionsTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewPositions from "@/components/Settings/UserAccountSettings/ViewPositions/ViewPositions.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabPositions",
	components: {
		DialogRemove,
		ViewPositions,
		MainTable
	},
	computed: {
		...mapGetters([
			'editPositions',
			'settingsPositions',
			'positionsPositions',
			'departmentsDepartments',
			'filtersPositions',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabPositionsTable;
		},
	},

	data: () => ({
		flag: TAB.POSITIONS,

		isViewPositions: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountPositionsList',
			'getAccountPositionsEdit',
			'getAccountDepartmentsList',
			'deleteAccountPositions',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_POSITIONS, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateList(key) {
			if (key === 'positions') {
				await this.getAccountPositionsList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';
			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabPositions' && key === 'edit1') {
				this.accountPositionsEdit();
			}
			if (nameComponent === 'tabPositions' && key === 'delete1') {
				const title = TITLE.REMOVE_POSITIONS;
				const text = TEXT.REMOVE_POSITIONS;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabPositions') {
				const { id } = this.activeItem;
				await this.deleteAccountPositions(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountPositionsEdit() {
			const { id } = this.activeItem;
			await this.getAccountPositionsEdit(id);
			this.isViewPositions = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewPositions = true;
		},
		onSaveViewPositions(args) {
			console.info('%c [ onSaveViewPositions args  ] ', 'color:#bada55', typeof args, args );
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountPositionsList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>

